// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.battery.claim,
    formValidation: state.claims.battery.formValidation,
    installedBy: state.claims.battery.installedBy,
    isEditable: state.claims.battery.isEditable,
    isValidClaim: state.claims.battery.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.battery.product,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/battery/components/claim-details-section/index.js